
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { userPriv, userInvalid } from "utils/privilege.util";
import { userType, userPrivilege } from "const/nuclias/user";

import { defaultRouteRule } from "router/config/config";

// Model
import User from "models/User";
import { pageContextActions } from "stores/slice/pageContext";
import { adminPageContextActions } from "stores/slice/adminPageContext";
import userService from "services/Auth.User.service";
import announcementService from "services/Auth.Announcement.service";

// Component
import MSPHeader from "ui/MSPHeader"; // for SI, MSP user
import OrgHeader from "ui/OrgHeader"; // for ORG, SiteTag, Site user
import Navigator from "ui/Navigator";

import { isNil } from "lodash";

const Headers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { user } = useSelector(store => store.user);
  const rule = defaultRouteRule[user.type];
  const [headerDp, setHeaderDp] = useState(null);
  const [alerts, setAlerts] = useState({
    alert: {
      unread: false,
      show: true,
    },
    announcement: {
      unread: false,
      show: true,
    },
  });

  const getHeaderDpRule = () => {
    setHeaderDp(rule[location.pathname]);
  };

  const logout = () => {
    User.removeTokenLocalStoreage();
    dispatch(pageContextActions.cleanAll());
    dispatch(adminPageContextActions.cleanAll());
    sessionStorage.removeItem('mspSelectedOrg');
    sessionStorage.removeItem('access_token');
    navigate('/login');
  };

  const getUnreadCount = async () => {
    if (user.type === userType.sp) {
      setAlerts(alerts => ({ ...alerts, alert: { ...alerts.alert, show: false } }));
      return;
    }
    const data = await userService.getUserUnreadCount();
    if (data?.data?.count > 0) {
      setAlerts(alerts => ({ ...alerts, alert: { ...alerts.alert, unread: true } }));
    }
  };

  const getAnnouncement = async () => {
    if (userPriv(userPrivilege.editor)) {
      setAlerts(alerts => ({ ...alerts, announcement: { ...alerts.announcement, show: false } }));
      return;
    }
    const data = await announcementService.getAnnouncement();
    let unread = false;
    const readAnnouncementList = user?.webSetting?.help?.announcement?.readAnnouncementList;
    for (const item of data?.data) {
      if (isNil(readAnnouncementList)) {
        unread = true;
        break;
      }
      if (readAnnouncementList.indexOf(item.id) === -1) {
        unread = true;
        break;
      }
    }
    setAlerts(alerts => ({ ...alerts, announcement: { ...alerts.announcement, unread } }));
  };

  const fetchAlertApis = () => {
    getUnreadCount();
    getAnnouncement();
  };

  useEffect(() => {
    fetchAlertApis();
  }, []);

  useEffect(() => {
    getHeaderDpRule();
  }, [location]); //pageContext

  return (
    <>
      {
        (user?.type === userType.sp || user?.type === userType.si) &&
        <MSPHeader
          logout={logout}
          alerts={alerts}
          headerDp={headerDp}
        />
      }
      {
        user?.type !== userType.sp && user?.type !== userType.si &&
        <OrgHeader
          logout={logout}
          alerts={alerts}
          headerDp={headerDp}
        />
      }
      {user && <Navigator />}
    </>
  );
};

export default Headers;